import React from 'react';

import {OTPForm} from '@features/Password/OTP';

export const TwoFAPage = () => <OTPForm />;
